import React from 'react'
import {useSortable} from '@dnd-kit/sortable'
import {CSS} from '@dnd-kit/utilities'

import Icon from '../general/Icon'
import {ICON} from '../../data/icons'


const minColumnWidth = 60

const OrdersHeaderCell = ({header, sortField, sortDirection, onSortClick, onResizeMove, onResizeCommit}) => {

    const {attributes, listeners, setNodeRef, transform, transition, isDragging} = useSortable({id: header.id})

    const startResize = (event) => {
        event.stopPropagation()
        event.preventDefault()
        const startX = event.clientX
        const startWidth = header.width
        let latestWidth = startWidth
        let frame = 0

        const handleMove = (moveEvent) => {
            latestWidth = Math.max(minColumnWidth, startWidth + (moveEvent.clientX - startX))
            if (frame) return
            frame = requestAnimationFrame(() => {
                frame = 0
                onResizeMove(header.id, latestWidth)
            })
        }
        const handleUp = () => {
            window.removeEventListener('pointermove', handleMove)
            window.removeEventListener('pointerup', handleUp)
            if (frame) cancelAnimationFrame(frame)
            onResizeMove(header.id, latestWidth)
            onResizeCommit(header.id, latestWidth)
        }
        window.addEventListener('pointermove', handleMove)
        window.addEventListener('pointerup', handleUp)
    }

    const style = {
        transform: CSS.Translate.toString(transform),
        transition,
        opacity: isDragging ? 0.4 : 1,
        zIndex: isDragging ? 2 : undefined
    }

    const sortIcon = sortField === header.field
        ? <Icon className='icon' icon={sortDirection === 'asc' ? ICON.SORT_ASC : ICON.SORT_DESC}/>
        : null

    return (
        <th ref={setNodeRef} style={style}>
            <div className='table-header'>
                <div
                    className='table-header__content'
                    {...attributes}
                    {...listeners}
                    onClick={() => onSortClick(header)}
                >
                    <div className='table-header__title'>{header.title}</div>
                    <div>{sortIcon}</div>
                </div>
                <div className='table-header__resize' onPointerDown={startResize}>
                    <Icon icon={ICON.RESIZE} className='icon'/>
                </div>
            </div>
        </th>
    )
}

export default OrdersHeaderCell
